<template>
  <v-dialog v-model="shippingOfflineLocationForm" no-click-animation persistent max-width="500">
    <v-card>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-title class="headline primary white--text">{{ dialogTitle }}</v-card-title>
        <v-card-text class="mt-20">
          <dynamic-form
            :watchKey="shippingOfflineLocationForm"
            :fieldGroups="shippingOfflineLocationFields"
            :bindObj="shippingOfflineLocation"
            :split="false"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="discard" class="white--text" color="primary" small depressed>
            Discard
          </v-btn>
          <v-btn
            @click="doSave"
            class="white--text"
            color="primary"
            :disabled="invalid || processing"
            small
            depressed
          >
            Save
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import shippingOfflineLocationFields from '@/models/shipping-offline-location-fields';
import _ from 'lodash';

export default {
  name: 'ShippingOfflineLocationForm',
  data() {
    return { oldShippingOfflineLocation: {}, processing: false };
  },
  computed: {
    ...mapState('shippingOfflineLocation', ['operation', 'generatedPassword']),
    shippingOfflineLocationFields() {
      return shippingOfflineLocationFields;
    },
    shippingOfflineLocationForm: {
      get: () => store.state.shippingOfflineLocation.shippingOfflineLocationForm,
      set: v => store.commit('shippingOfflineLocation/setShippingOfflineLocationForm', v)
    },
    shippingOfflineLocation: {
      get() {
        const { shippingOfflineLocation } = store.state.shippingOfflineLocation;
        if (this.operation === 'create') return shippingOfflineLocation;
        return _.cloneDeep(shippingOfflineLocation);
      },
      set: v => store.commit('shippingOfflineLocation/setShippingOfflineLocation', v)
    },
    dialogTitle() {
      if (this.operation === 'create') return 'Create New Shipping Offline Location';
      return `Update Shipping Offline Location`;
    }
  },
  methods: {
    ...mapMutations('shippingOfflineLocation', ['toggleShippingOfflineLocationForm']),
    ...mapActions('shippingOfflineLocation', [
      'createShippingOfflineLocation',
      'updateShippingOfflineLocation'
    ]),
    async doSave() {
      const { operation, shippingOfflineLocation } = this;
      this.processing = true;
      if (operation === 'create') {
        await this.createShippingOfflineLocation(shippingOfflineLocation);
      } else {
        await this.updateShippingOfflineLocation(shippingOfflineLocation);
      }
      this.processing = false;
      this.$refs.observer.reset();
      this.oldShippingOfflineLocation = _.cloneDeep(this.shippingOfflineLocation);
      this.toggleShippingOfflineLocationForm();
    },
    discard() {
      this.toggleShippingOfflineLocationForm();
      this.shippingOfflineLocation = _.cloneDeep(this.oldShippingOfflineLocation);
      this.$refs.observer.reset();
    }
  },
  watch: {
    async shippingOfflineLocationForm(n) {
      if (n) this.oldShippingOfflineLocation = _.cloneDeep(this.shippingOfflineLocation);
    }
  }
};
</script>
